import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { translate } from "react-i18next";
import de from 'date-fns/locale/de';
import i18n from "i18next";
import { CITIES,  PUB_CATEGORIES, ACT_CATEGORIES } from "../../backend/Data";
import { getTransValue } from "../../backend/UIUtils"
import { Form, Button, Card } from 'react-bootstrap';

registerLocale('de', de)

function emptyCriteria() {
    return {
        eventCategory: '',
        city: '',
        startDate: new Date().getTime(),
        endDate: new Date().getTime(),
        notified: '',
        searchType: ''
    };
}


class AdminSearch extends Component {

    constructor(...args) {
        super(...args);

        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.searchEvent = this.searchEvent.bind(this);

        this.state = {
            criteria: emptyCriteria(),
            category: null
        };
    }


    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { criteria } = this.state;

        let selectedCat = this.state.category;
        if (obj.target.name === 'eventCategory') {
            let isPublicEvent = this.state.criteria.searchType === 'PUBLIC' ? true : false;
            let all = isPublicEvent ? PUB_CATEGORIES : ACT_CATEGORIES;
            if ("0" === obj.target.value) {
                selectedCat = null;
            } else {
                let filteredcat = all.filter(cat => cat.code === obj.target.value);

                if (filteredcat && filteredcat.length > 0) {
                    selectedCat = filteredcat[0];
                }
            }

        }

        const newEvent = {
            ...criteria,
            [fieldName]: fieldValue
        };

        this.setState({
            category: selectedCat,
            criteria: newEvent
        });
    }

    onEventStartDateChange(obj) {
        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            startDate: obj ? obj.getTime() : null
        };

        this.setState({
            criteria: newEvent
        });
    }

    onEventEndDateChange(obj) {
        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            endDate: obj ? obj.getTime() : null
        };

        this.setState({
            criteria: newEvent
        });
    }

    handleChange( e) {

        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            notified: e.target.checked
        };

        this.setState({
            criteria: newEvent
        });

       
    }


    searchEvent() {
        this.props.searchEvents(this.state.criteria, 1);
    }

    async componentDidMount() {
        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            searchType: this.props.searchType ? this.props.searchType : 'PUBLIC'
        };

        this.setState({
            criteria: newEvent
        });
    }

    render() {
        let lang = i18n.language;
        const { t } = this.props;
        let isPublicEvent = this.state.criteria.searchType === 'PUBLIC' ? true : false;
        const { criteria: { eventCategory, city, startDate, endDate, subCategory, notified } } = this.state;
        let borderClass = isPublicEvent ? "primary" : "success";
        return (
            <div>
                <Card text={"black"} className="mb-2 bold">
                    <Card.Header ><i className="fa fa-search mr-1"></i>{this.state.criteria.searchType === 'PUBLIC' ? t("searchPublic") : t("searchActivity")}</Card.Header>
                    <Card.Body className="pb-0">
                        <Form>
                            <Row >
                                <Col className="float-right " md={12} lg={3} xl={3}>
                                    <Form.Group controlId="what" >
                                        <Form.Label>{t("what") + "?"}</Form.Label>
                                        <Form.Control as="select" name="eventCategory" value={eventCategory} onChange={this.onEventInputChange} defaultValue="0">
                                            <option value="0">{t("catChoose")}</option>
                                            {(isPublicEvent ? PUB_CATEGORIES : ACT_CATEGORIES).map(c =>
                                                <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col className="float-right " md={12} lg={3} xl={3}>
                                    <Form.Group controlId="what" >
                                        <Form.Label>&nbsp;</Form.Label>
                                        <Form.Control as="select" name="subCategory" value={subCategory} onChange={this.onEventInputChange} defaultValue="0" disabled={!this.state.category}>
                                            <option value="0">{t("subCatChoose")}</option>
                                            {this.state.category ?
                                                this.state.category.subs.map(c =>
                                                    <option value={c.code} key={c.code} label={getTransValue(c, lang)}></option>
                                                )
                                                : ''

                                            }

                                        </Form.Control>
                                    </Form.Group>
                                </Col>


                                <Col className="  float-right " md={12} lg={6} xl={2}>
                                    <Form.Group controlId="where">
                                        <Form.Label>{t("where") + "?"}</Form.Label>
                                        <div>
                                            <Form.Control list="cities"
                                                name="city"
                                                onChange={this.onEventInputChange}
                                                value={city}
                                                placeholder={t("sucheWo")} block="true"
                                            />
                                            <datalist id="cities">
                                                {CITIES.map(c =>
                                                    <option value={getTransValue(c, lang)} key={getTransValue(c, lang)} />
                                                )}

                                            </datalist></div>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="float-left " md={12} lg={6} xl={2}>
                                    <Form.Group controlId="when">
                                        <Form.Label>{t("from") + "?"}</Form.Label>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={this.onEventStartDateChange}
                                            dateFormat="dd MMM yyyy"
                                            locale="de"
                                            className="form-control"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="float-left " md={12} lg={6} xl={2}>
                                    <Form.Group controlId="when">
                                        <Form.Label>{t("to") + "?"}</Form.Label>
                                        <DatePicker
                                            selected={endDate}
                                            onChange={this.onEventEndDateChange}
                                            dateFormat="dd MMM yyyy"
                                            locale="de"
                                            className="form-control"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="notified">
                                        <Form.Label>{t("onlyNotified") + "?"}</Form.Label>
                                        
                                        <Form.Check  name="notified" id="notified" checked={notified} onChange={this.handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={12} lg={6} xl={2}>
                                    <Row>
                                        <Col>&nbsp;</Col>
                                    </Row>
                                    <Row className="mt-2 pl-0">
                                        <Col><Button variant={borderClass} onClick={this.searchEvent} block size="sm">
                                            <i className="fa fa-search mr-1"></i>{this.state.criteria.searchType === 'PUBLIC' ? t("search") : t("search")}
                                        </Button></Col>
                                    </Row>


                                </Col>

                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default translate("translations")(AdminSearch);